import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as enums from '../enums'

export const TRANSFORMER = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.extra.space.Record.Update,
    graphql.schema.SpaceRecordUpdate
  >({
    anomalies: graphql.transformers.IN.list(enums.anomaly.TRANSFORMER, {
      onNullish: 'remove',
    }),
    comment: transformers.PASS_THROUGH,
    description: transformers.PASS_THROUGH,
    roomTypeId: graphql.transformers.IN.validate(
      transformers.PASS_THROUGH,
      ents.core.dms.data.Record.Id.assertIsId,
      { warnOnly: true },
    ),
  }),
)
